import { onDocumentReady } from '@theme/utilities';

/**
 * Reveals the footer logo once the covering footer content has scrolled past it.
 * IntersectionObserver alone cannot detect occlusion behind another element.
 */
function initFooterLogoReveal() {
  const logo = document.querySelector('.footer-logo');
  const footer = document.querySelector('.footer-container');
  const inner = logo?.querySelector('.footer-logo__inner');

  if (!logo || !footer || !inner) return;

  let ticking = false;

  const update = () => {
    ticking = false;
    const revealed = footer.getBoundingClientRect().bottom <= logo.getBoundingClientRect().top + 1;

    inner.classList.toggle('in-view-trigger--in-view', revealed);
  };

  const scheduleUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate, { passive: true });
  update();
}

onDocumentReady(initFooterLogoReveal);

if (window.Shopify?.designMode) {
  document.addEventListener('shopify:section:load', initFooterLogoReveal);
}
